var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full max-w-content-double mx-auto px-4",attrs:{"modules-divider":""}},[_c('div',{staticClass:"border-b border-black"})])
}]

export { render, staticRenderFns }